import type { BackendTypes } from '@tf/api';
import { Box, Button, Group, Icon, TFCard, Tooltip } from '@tf/ui';
import type { FormSegment } from '@tf/utils';
import type React from 'react';
import { FormStatusLabelBase } from '@/components/reviews/ReviewForm/FormStatusLabel';
import { UserCapabilities } from '@/core/types';
import { useCurrentUserCapabilityCheck } from '@/core/utils';

interface Props {
	isLoading: boolean;
	isDirty: boolean;
	graphId: number;
	segments: FormSegment[];
	status?: BackendTypes.FieldValidationStatus;
}

export const EntityFormFooter: React.FC<Props> = ({ isLoading, isDirty, segments, status }) => {
	const canPrepareAccountsData = useCurrentUserCapabilityCheck(UserCapabilities.CAN_PREPARE_ACCOUNTS_DATA);

	const isReadOnly = segments.every((s) => s.accessMode === 'VIEW');

	return (
		<TFCard innerPadding=".75rem 1rem">
			<Group
				gap="md"
				sx={{
					display: 'flex',
					flexWrap: 'nowrap',
					justifyContent: 'end',
					alignItems: 'center',
				}}
			>
				<Box sx={{ flexGrow: 1, flexShrink: 1, minWidth: 0 }}>
					<FormStatusLabelBase status={status} />
				</Box>
				{canPrepareAccountsData && !isReadOnly && (
					<Tooltip label="All form data is saved" disabled={isDirty || isLoading} openDelay={500}>
						<Button
							loading={isLoading}
							disabled={!isDirty || isLoading}
							leftSection={<Icon.IconDeviceFloppy size={16} />}
							type="submit"
						>
							{isDirty ? 'Save' : 'Saved'}
						</Button>
					</Tooltip>
				)}
			</Group>
		</TFCard>
	);
};
